import { FilterValueType, FilterOperator } from "../types"

/** Serialize value for filter by adding quotes in case value type is string and value contains spaces. */
export const serializeFilterValue = (value: string | boolean | number, valueType?: FilterValueType) => {
  if (typeof value === 'boolean' || typeof value === 'number') {
    return value.toString()
  } else if ((valueType === FilterValueType.string || valueType === undefined) && value.indexOf(' ') !== -1) {
    return `"${value}"`
  } else {
    return value
  }
}

/** Serialize operator for filter, default to eq. */
export const serializeFilterOperator = (operator?: FilterOperator) => FilterOperator[operator ?? FilterOperator.eq]

/** Determine name for field to store operator for field with given id in (url) state. */
export const fieldIdForOperator = (id: string) => `${id}-o`